import { render, staticRenderFns } from "./reports-page.vue?vue&type=template&id=0c26263e&scoped=true"
import script from "./reports-page.vue?vue&type=script&lang=js"
export * from "./reports-page.vue?vue&type=script&lang=js"
import style0 from "./reports-page.vue?vue&type=style&index=0&id=0c26263e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26263e",
  null
  
)

export default component.exports